import { MultiplicityPatterns } from '../constants/MultiplicityPatterns';
let possiblePatterns = [];
for (const { label, value, names } of MultiplicityPatterns) {
    possiblePatterns.push(label, value, ...names);
}
possiblePatterns = possiblePatterns.sort((a, b) => b.length - a.length);
/**
 * split a composed pattern like dt or ddt into ['d','t'] and ['d','d','t']
 * @param multiplet - pattern or abbreviation.
 * @returns
 */
export function splitPatterns(multiplet) {
    if (/^\s*$/.exec(multiplet))
        return [];
    const regexp = new RegExp(possiblePatterns.join('|'), 'g');
    const result = multiplet.match(regexp);
    if (result)
        return result.map((entry) => entry.trim());
    return [multiplet];
}
//# sourceMappingURL=splitPatterns.js.map